module.exports = __webpack_public_path__ + "static/media/pole-small.9feb2302.webp";